var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    baseProfile: "tiny",
    overflow: "visible",
    viewBox: "0 0 140 128.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m122.5 110.8-11-8.5C53.3 115.3 26 98 22.4 84.1L10 89.4c-2.4-6.9-1.4-18.7 10-33l1.7-6.8C11.1 59.9-.9 75.6.1 93.2c1.7 30.9 66.2 29.2 66.2 29.2 27 0 56.2-11.6 56.2-11.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96.7 122.8c-5.4 1.1-11.2 2-17.1 2.4 0 0-2.1.2-5.6.3 24.4 6.2 50.7-1.9 66.3-22.4-12.7 13.2-30 18-43.6 19.7zm-17-19c-21.5-6.5-39.2-22.6-44.9-43.5C26.3 29.1 44.4 6.5 79.3.4c1-.2 1.9-.3 2.9-.4-18.4 1.1-35.8 10-47.1 25.8-11.4 15.9-14.1 35.6-9 53.4 1 3.5 2.3 6.9 3.8 10.2.5 1 1 2.1 1.6 3.1 9.3 7.1 24.9 12.1 48.2 11.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100.2 12.4c-12.7-.4-26.5 2.4-41.3 8.4-.8.3-1.6.7-2.5 1l-3.1 1.3 1.9 4.3c-6.7 3-12.8 6.3-18.3 9.9-.1 1-.2 2-.2 3.1.3-.2.5-.4.6-.5 4.7-3.2 9.6-5.7 15.5-8.3l2.6-1.1c.3-.1.6-.3.9-.4 12.7-5.3 24.5-7.8 35.4-7.4 11.2.3 18.3 3.5 21.2 9.5l7.6-3.3.5 1.2c2.4 6.3-.1 13.6-7.5 22.1C106 60.7 95.4 68 81.9 74c-1.8.8-3.6 1.5-5.4 2.2-3.1 1.2-6.2 2.2-9.2 3.1-.5 1.8-.1 3.2 1.7 3.6 5.1-2.2 8.7-4 8.7-4l3.1-1.3c15.6-7 27.8-15.6 36.6-25.7 9.2-10.5 12-19.6 8.7-27.3-3.4-7.8-12-11.8-25.9-12.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthcam);
export default __webpack_public_path__ + "static/media/earthcam.e8ccfbe9c55f5008a603f6fe985a7619.svg";
export { ForwardRef as ReactComponent };